/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// @mui material components
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



import { CustomToastContent } from "../../../examples/CustomToastContent/index";

// import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component and styling
import Select from "react-select";

//  config file
import Config from "../../../config/index";

// Functions from store
import {
  createCustody,
  createDynamicColumn,
  deleteCustody,
  editCustody,
  getAcn,
  getCustody,
  getDppDocumentsImage,
  getDppIds,
  getDynamicColumn,
  getFromEntityFromDppId,
  getItemMaster,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getLevelsByWarehouse,
  getLocationFromCustody,
  getOpenBinsByWarehouseAndZone,
  getRelationLocation,
  getSubModulesByRoleId,
  getWarehouses,
  getWarehousesByMovement,
  getZonesByWarehouse,
  uploadForCustody,
  uploadForUrl,
} from "../../../store";

// Cookies
import { Backdrop } from "@mui/material";
import MDInput from "components/MDInput";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import EditButton from "components/standardized-components/EditButton";
import UploadButton from "components/standardized-components/UploadButton";
import { format } from "date-fns";
import { CSVLink } from "react-csv";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "hidden",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Custody = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  createDynamicColumn,
  getWarehouses,
  deleteCustody,
  warehouses,
  getCustody,
  getCustodyReducer,
  getItemMaster,
  getDppIds,
  dppIdSelectedForGlobalFilter,
  getDynamicColumn,
  itemMaster,
  getZonesByWarehouse,
  zonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocationReducer,
  getLevel1ByLevel,
  getWarehouseByMovementReducer,
  getLevel2ByLevel,
  getLocationFromReducer,
  getLevel3ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevel,
  getLevel4ByLevelReducer,
  editCustody,
  getAcn,
  getFromEnitityReducer,
  getFromEntityFromDppId,
  getRelationLocation,
  createCustody,
  getWarehousesByMovement,
  uploadForCustody,
  getLevelsByWarehouse,
  uploadForUrl,
  levelsByWarehouseReducer,
  getLocationFromCustody,
  getDynamicColumnReducer,
  getDPPReducer,
  getDppDocumentsImageReducer,
  getDppDocumentsImage,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "269b317f-3fc3-4ce8-b885-0817acf36a66",
  );
  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "f8b1ef1b-b218-4c93-b3fb-57a20162e5b9",
    )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "1f130e9a-11bf-4ad3-b690-4fcefedfbb44",
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "c56badff-b363-436a-9fca-5e0275dfb6ef",
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "094cfd74-eeea-4ec5-b12d-00871edd2e50",
    )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [warehouseIdSelected, setWarehouseIdSelected] = useState("");
  const [zoneIdSelected, setZoneIdSelected] = useState("");
  const [sectionIdSelected, setSectionIdSelected] = useState("");
  const [rackIdSelected, setRackIdSelected] = useState("");
  const [locationIdSelected, setLocationIdSelected] = useState("");
  const [activityIdSelected, setActivityIdSelected] = useState("");

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
    setWarehouseIdSelected("");
  };

  const handleChangeWarehouse = (selectedData) => {
    setWarehouseIdSelected(selectedData);
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleZoneIDChange = (selectedRack) => {
    setZoneIdSelected(selectedRack);
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleSectionIdChange = (selectedRack) => {
    setSectionIdSelected(selectedRack);
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleRackIdChange = (selectedRack) => {
    setRackIdSelected(selectedRack);
    setLocationIdSelected("");
  };

  const handleLocationIdChange = (selectedLocation) => {
    setLocationIdSelected(selectedLocation);
  };

  // useEffect(() => {
  //   getCustody(jwtToken);
  // }, []);

  const [selectedZoneName, setSelectedZoneName] = useState("");

  const handleZoneNameChange = (selectedZoneName) => {
    setSelectedZoneName(selectedZoneName);
    setRackIdSelected("");
  };

  const [state, setState] = useState({
    columns: [
      { Header: "Chain ID", accessor: "chainId" },
      { Header: "DPP Code", accessor: "dppCode" },
      // { Header: "description", accessor: "description" ,   width: 320, },
      { Header: "From Entity", accessor: "fromEntity" },
      { Header: "To Entity", accessor: "toEntity" },
      { Header: "Mode", accessor: "transferMode" },
      { Header: "From Location", accessor: "locationFrom" },
      { Header: "To Location", accessor: "locationTo" },
      { Header: "carbon Footprint (kg CO₂e)  ", accessor: "carbonFootprint" },
      {
        Header: "Transfer Date",
        accessor: "transferDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value ? format(new Date(value), "dd/MM/yyyy") : "";
        },
      },

      // { Header: "Created By", accessor: "acnCode" },
      {
        Header: "file",
        accessor: "attachments",
        cannotSearch: true,
        cannotSort: true,
      },

      {
        Header: "Certificate",
        accessor: "attachments2",
        cannotSearch: true,
        cannotSort: true,
      },

      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  // const headers = [
  //   { label: "chainId", key: "chainId" },
  //   { label: "dppCode", key: "dppCode" },
  //   // { label: "description", key: "description" },
  //   { label: "fromEntity", key: "fromEntity" },
  //   { label: "toEntity", key: "toEntity" },
  //   { label: "transferMode", key: "transferMode" },
  //   { label: "locationFrom", key: "locationFrom" },
  //   { label: "locationTo", key: "locationTo" },
  //   { label: "carbonFootprint (kg CO₂e) ", key: "carbonFootprint" },

  //   { label: "transferDate", key: "createdDate" },
  // ];
  // const headersForTemp = [
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "fromEntity", key: "fromEntity" },
  //   { label: "toEntity", key: "toEntity" },
  //   { label: "transferDate", key: "transferDate" },
  //   { label: "transferMode", key: "transferMode" },
  //   { label: "locationFrom", key: "locationFrom" },
  //   { label: "locationTo", key: "locationTo" },
  //   { label: "carbonFootprint", key: "carbonFootprint" },
  //   { label: "orderNo", key: "orderNo" },
  // ];

  // --- 1. Table Data Download (Listing) ke Headers ---
  const headers = [
    { label: "DPP Code", key: "dppCode" },
    { label: "From Entity", key: "fromEntity" },
    { label: "To Entity", key: "toEntity" },
    { label: "Transfer Date", key: "createdDate" },
    { label: "Transfer Mode", key: "transferMode" },
    { label: "Location From", key: "locationFrom" },
    { label: "Location To", key: "locationTo" },
    { label: "Carbon Footprint (kg CO₂e)", key: "carbonFootprint" },

    // { label: "Chain ID", key: "chainId" },
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "fromEntity", key: "fromEntity" },
    { label: "toEntity", key: "toEntity" },
    { label: "transferDate", key: "transferDate" },
    { label: "transferMode", key: "transferMode" },
    { label: "locationFrom", key: "locationFrom" },
    { label: "locationTo", key: "locationTo" },
    { label: "carbonFootprint", key: "carbonFootprint" },
  ];

  const csvLink = {
    filename: "Custody List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Custody Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [currentFile, setCurrentFile] = useState(null);

  const handleOpenDocument = (item, attachmentIndex) => {
    const attachment = item.attachments?.[attachmentIndex];

    if (!attachment?.attachmentId) {
      // console.log("No valid attachment found");
      return;
    }

    getDppDocumentsImage(
      attachment.moduleName,
      attachment.type,
      attachment.name,
      jwtToken,
    );
  };

  // Watch reducer for updates
  useEffect(() => {
    const data = getDppDocumentsImageReducer.documents.data;

    if (data) {
      // Set the file for temporary use
      setCurrentFile(data);

      // Reset local state in reducer copy
      getDppDocumentsImageReducer.documents.data = null; // clears it locally
    }
  }, [getDppDocumentsImageReducer.documents.data]);

  // Optional: automatically clear currentFile after some time
  useEffect(() => {
    if (currentFile) {
      const timer = setTimeout(() => setCurrentFile(null), 1000); // 5 seconds
      return () => clearTimeout(timer);
    }
  }, [currentFile]);

  // Open file whenever currentFile updates
  useEffect(() => {
    if (!currentFile) return;

    let fileUrl;
    if (typeof currentFile === "string") fileUrl = currentFile;
    else if (currentFile.url) fileUrl = currentFile.url;
    else if (currentFile.base64) {
      const byteCharacters = atob(currentFile.base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: currentFile.type || "application/octet-stream",
      });
      fileUrl = URL.createObjectURL(blob);
    } else return;

    window.open(fileUrl, "_blank", "noopener,noreferrer");
  }, [currentFile]);

  const [dppIdSelected, setdppIdSelected] = useState("");

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempMappedActivity = [];
    let data = getCustodyReducer.custody.data
      ? getCustodyReducer.custody.data
      : [];
    setPaginationObj(getCustodyReducer?.custody?.pagination);
    setLoading(getCustodyReducer.loading);
    data.map((item) => {
      const formatDate = new Date(item.transferDate);
      let itemDescription = item.itemDescription;
      let len = desLength;
      const itemObject = {
        privateKey: item.itemCode,
        itemCodeDes: `${item.itemCode} / ${itemDescription ? itemDescription.substring(0, len) : ""
          }`,
        chainId: item.chainId,
        dppCode: item.dppCode,
        description: item.description,
        fromEntity: item.fromEntity,
        toEntity: item.toEntity,
        transferMode: item.transferMode,
        locationFrom: item.locationFrom,
        carbonFootprint: item.carbonFootprint,
        locationTo: item.locationTo,

        attachments:
          item.attachments?.length > 0 && item.attachments[0]?.attachmentId ? (
            <MDButton
              variant="gradient"
              color="info"
              iconOnly
              disabled={item.attachments==null}
              size="small"
              style={{ padding: "4px", minWidth: "32px" }}
              onClick={() => handleOpenDocument(item, 0)}
            >
              <Icon>description</Icon>
            </MDButton>
          ) : (
            "-"
          ),

        attachments2:
          item.attachments?.length > 1 && item.attachments[1]?.attachmentId ? (
            <MDButton
              variant="gradient"
              color="info"
              iconOnly
              size="small"
              style={{ padding: "4px", minWidth: "32px" }}
              onClick={() => handleOpenDocument(item, 1)}
            >
              <Icon>description</Icon>
            </MDButton>
          ) : (
            "-"
          ),

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {item?.itemDescription?.length > 35 ? (
              <Tooltip
                title={item.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {item.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {item.itemDescription}
              </MDTypography>
            )}
            {item?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        id: item.id,
        categoryCode: item.categoryCode,
        warehouse: item.warehouseCode,
        transferDate: item.transferDate,
        zone: item.zone,
        section: item.section,

        createdDate: format(new Date(formatDate), "dd/MM/yyyy"),
        cd: item.cd,
        rack: item.rack,
        location: item.location,
        // itemName: des ? des.substring(0, len) : "",
        acnCode: item.acnCode,
        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenUpdateModal(item);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    viewAccess && setState({ ...state, rows: tempMappedActivity });
  }, [getCustodyReducer]);

  const [entityOptions, setFromEntityOptions] = useState([]);

  const [locationFromOptions, setLocationFromOptions] = useState([]);

  const [warehouseOptionsByMovement, setWarehouseOptionsByMovement] = useState(
    [],
  );

  useEffect(() => {
    getFromEntityFromDppId(dppIdSelected?.value, jwtToken);
  }, [dppIdSelected]);

  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getWarehouseByMovementReducer.warehouses.data
      ? getWarehouseByMovementReducer.warehouses.data
      : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptionsByMovement(tempWarehouseOptions);
  }, [getWarehouseByMovementReducer]);

  const handleChangeDpp = (selectedData) => {
    setdppIdSelected(selectedData);
  };

  //   useEffect(() => {
  //   if (dppIdSelectedForGlobalFilter) {
  //     setdppIdSelected(dppIdSelectedForGlobalFilter);
  //   }
  // }, [dppIdSelectedForGlobalFilter]);

  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      // Fetch with dppId + jwtToken
      getCustody(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      // Fetch without filter
      getCustody(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);

  const [dppOptions, setDPPOptions] = useState([]);

  useEffect(() => {
    getDppIds(jwtToken);
  }, []);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getDPPReducer.dpp.data ? getDPPReducer.dpp.data : [];
    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.dppCode,
        value: zone.dppId,
        industryId: zone.industryId,
        industryName: zone.industryName,
      });
    });
    setDPPOptions(tempgetDPPReducer);
  }, [getDPPReducer]);

  const [dppIdForUpdateSelected, setdppIdForUpdateSelected] = useState("");
  const handleChangeDppForUpdate = (selectedData) => {
    setdppIdForUpdateSelected(selectedData);
  };
  const selectedDppId =
    dppIdSelected?.value || dppIdSelectedForGlobalFilter?.value;

  useEffect(() => {
    if (selectedDppId) {
      getLocationFromCustody(selectedDppId, jwtToken);
    }
  }, [selectedDppId, jwtToken]);

  // useEffect(() => {
  //   let tempLevelOptions = [];
  //   let data = getRelationLocationReducer.locations.data
  //     ? getRelationLocationReducer.locations.data
  //     : [];

  //   data.map((level) => {
  //     tempLevelOptions.push({
  //       label: level.rltName,
  //       value: level.rltLevel,
  //     });
  //   });
  //   setLevelOptions(tempLevelOptions);
  // }, [getRelationLocationReducer]);

  // let level1Name = getRelationLocationReducer.locations.data

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [zoneOptions, setZoneOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = zonesByWarehouse.zones.data ? zonesByWarehouse.zones.data : [];
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.zoneName,
        value: zone.id,
      });
    });
    setZoneOptions(tempZonesByWarehouse);
  }, [zonesByWarehouse]);

  // useEffect(() => {
  //   getLevelsByWarehouse(warehouseIdSelected?.value, jwtToken);
  // }, [warehouseIdSelected]);

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const [openBinsOptions, setOpenBinsOptions] = useState([]);

  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
    formik.setValues(initialValues);

    setZoneIdSelected("");
    setWarehouseIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleCloseAllocateItemModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});

    setdppIdSelected("");
    formik.setValues(initialValues);
    setWarehouseIdSelected("");
    setLocationIdSelected("");
    setActivityIdSelected("");
    setSelectedItemCode("");
  };

  const [ActivityMappingData, setActivityMappingData] = useState({});

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [selectedBin, setSelectedBin] = useState("");

  const handleBinChange = (selectedBin) => {
    setSelectedBin(selectedBin);
  };
  const [selectedBinForAdd, setSelectedBinForAdd] = useState("");

  const handleBinChangeForAdd = (selectedBinForAdd) => {
    setSelectedBinForAdd(selectedBinForAdd);
  };

  const [selectedOpenBin, setSelectedOpenBin] = useState(
    ActivityMappingData?.locationName,
  );

  useEffect(() => {
    if (ActivityMappingData) {
      setSelectedOpenBin({
        label: ActivityMappingData?.locationName,
        value: ActivityMappingData?.locationName,
      });
    }
  }, [ActivityMappingData]);

  const handleOpenBinChange = (selectedOpenBin) => {
    setSelectedOpenBin(selectedOpenBin);
  };

  const initialValues = {
    ToEntity: "",
    DPPID: "",
    FromEntity: "",
    TransferDate: "",
    LocationFrom: "",
    LocationTo: "",
    TransferMode: "",
    ProofDocumentURL: "",
    transportCertification: null,
  };

  const today = new Date().toISOString().split("T")[0];

  const validationSchema = Yup.object({
    // Dropdown object fields

    //  DPPID: Yup.object()
    //    .required("Select DPP Code"),

    // String fields from initialValues
    FromEntity: Yup.string().trim().required(" "),

    ToEntity: Yup.string().trim().required(" "),

    TransferDate: Yup.date()
      .required(" ")
      .min(today, "TransferDate cannot be a past date"),

    LocationFrom: Yup.string().trim().required(" "),

    LocationTo: Yup.string().trim().required(" "),

    TransferMode: Yup.string().trim().required(" "),

    transportCertification: Yup.mixed().required(" "),
  });

  const getValidationSchema = (industryId) => {
    const id = Number(industryId);
    const today = new Date().toISOString().split("T")[0];

    return Yup.object({
      FromEntity: Yup.string().trim().required(" "),
      ToEntity: Yup.string().trim().required(" "),
      TransferDate: Yup.date()
        .required(" ")
        .min(today, "TransferDate cannot be a past date"),
      LocationFrom: Yup.string().trim().required(" "),
      LocationTo: Yup.string().trim().required(" "),
      TransferMode: Yup.string().trim().required(" "),
      carbonFootprint: Yup.string().trim().required(" "),

      transportCertification:
        id === 9 ? Yup.mixed().nullable() : Yup.mixed().required(" "),
    });
  };

  const [errorMsg, setErrorMsg] = useState("");

  const [allocateButtonName, setAllocateButtonName] = useState("Create");

  const onSubmit = async (values, { resetForm }) => {
    setAllocateButtonName("Please wait...");

    const formData = new FormData();

    formData.append("cdBy", userId);
    formData.append("dppId", dppIdSelected?.value);
    formData.append("transferDate", values.TransferDate);
    formData.append("fromEntity", values.FromEntity);
    formData.append("toEntity", values.ToEntity);
    formData.append("carbonFootprint", values.carbonFootprint);
    formData.append("locationFrom", values.LocationFrom);
    formData.append("locationTo", values.LocationTo || "");
    formData.append("transferMode", values.TransferMode);
    formData.append("documentType", "custodyImage");
    formData.append("moduleName", "chainOfCustody");

    const documentDetails = [];

    if (values.file) {
      formData.append("attachments", values.file);

      documentDetails.push({
        fileName: values.file.name,
        fileType: "custodyImage",
      });
    }

    if (values.transportCertification) {
      formData.append("transportCertificate", values.transportCertification);
    }

    formData.append("documentDetails", JSON.stringify(documentDetails));

    let res = await createCustody(formData, jwtToken);

    if (res.status) {
      setIsSuccessAllocateItem(true);
      getOpenBinsByWarehouseAndZone(warehouseIdSelected?.value, zoneIdSelected);
      getCustody(dppIdSelectedForGlobalFilter?.value, jwtToken);
      formik.setErrors({});

      setActivityIdSelected("");
      setWarehouseIdSelected("");
      setZoneIdSelected("");
      setSectionIdSelected("");
      setRackIdSelected("");
      setLocationIdSelected("");

      setTimeout(() => {
        setAllocateButtonName("Create");
        handleCloseAllocateItemModal();
      }, 2250);
    } else {
      setErrorMsg(res?.data?.data?.msg);
      setAllocateButtonName("Create");
      setIsErrorAllocateItem(true);
    }

    // resetForm();
  };

  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSingleDataForDelete(data);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const [isErrorDeleteAssembly, setIsErrorDeleteAssembly] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState(false);
  const [isSuccessForAssembly, setIsSuccessForAssembly] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAssembly) {
      setTimeout(() => {
        setIsErrorDeleteAssembly(false);
      }, 3000);
    }
  }, [isErrorDeleteAssembly]);
  useEffect(() => {
    if (isSuccessForAssembly) {
      setTimeout(() => {
        setIsSuccessForAssembly(false);
      }, 2000);
    }
  }, [isSuccessForAssembly]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteTripNo = async () => {
    setDeleteButtonName("Please wait...");
    let chainId = singleDataForDelete.chainId;
    let userId = singleDataForDelete.userId;

    let res = await deleteCustody(chainId, userId, jwtToken);

    if (res.status) {
      getCustody(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 3000);
      setIsSuccessForAssembly(true);
    }

    if (!res.status) {
      setIsErrorDeleteAssembly(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
      setDeleteButtonName("Delete");
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    // validationSchema,

    validationSchema: () => getValidationSchema(dppIdSelected?.industryId),
  });
  useEffect(() => {
    const data = getFromEnitityReducer?.custody?.data || [];

    formik.setFieldValue("FromEntity", "");
    setFromEntityOptions([]);

    // ❗ No DPP selected → stop here
    if (!formik.values.DPPID) return;

    // ❗ DPP selected but no data → keep empty
    if (data.length === 0) return;

    // ✅ Build options
    const tempOptions = data.map((activity) => ({
      label: activity.toEntity,
      value: activity.toEntity,
    }));

    setFromEntityOptions(tempOptions);

    // ✅ Auto-fill ONLY when valid
    formik.setFieldValue("FromEntity", data[0].toEntity);
  }, [formik.values.DPPID, getFromEnitityReducer]);

  useEffect(() => {
    const data = getLocationFromReducer?.custody?.data || [];

    // 🔥 Always reset when DPP changes or reducer updates
    formik.setFieldValue("LocationFrom", "");
    setLocationFromOptions([]);

    // ❗ No DPP selected → stop
    if (!formik.values.DPPID) return;

    // ❗ DPP selected but no data → keep empty
    if (data.length === 0) return;

    // ✅ Build options
    const tempWarehouseOptions = data.map((warehouse) => ({
      label: warehouse.locationTo,
      value: warehouse.locationTo,
    }));

    setLocationFromOptions(tempWarehouseOptions);

    // ✅ Auto-fill only when valid data exists
    formik.setFieldValue("LocationFrom", tempWarehouseOptions[0].value);
  }, [formik.values.DPPID, getLocationFromReducer]);

  const [isSuccessAddActivityMapping, setIsSuccessAddActivityMapping] =
    useState(false);
  const [isErrorAddActivityMapping, setIsErrorAddActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessAddActivityMapping) {
      setTimeout(() => {
        setIsSuccessAddActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessAddActivityMapping]);

  useEffect(() => {
    if (isErrorAddActivityMapping) {
      setTimeout(() => {
        setIsErrorAddActivityMapping(false);
      }, 3000);
    }
  }, [isErrorAddActivityMapping]);

  const [addActivityMappingModal, setAddActivityMappingModal] = useState(false);
  const handleAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };
  const handleCloseAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };

  const initialValueForAddActivityMapping = {
    bin: "",
  };

  const validationSchemaForAddActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForAddActivityMapping = async (values, { resetForm }) => {
    const payload = {
      warehouseId: warehouseIdSelected?.value,
      itemId: ActivityMappingData.itemId,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedBinForAdd.value,
    };

    setSelectedBinForAdd("");
    resetForm();
  };

  const formikForAdd = useFormik({
    initialValues: initialValueForAddActivityMapping,
    validationSchema: validationSchemaForAddActivityMapping,
    onSubmit: onSubmitForAddActivityMapping,
  });

  const [isSuccessEditActivityMapping, setIsSuccessEditActivityMapping] =
    useState(false);
  const [isErrorEditActivityMapping, setIsErrorEditActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessEditActivityMapping) {
      setTimeout(() => {
        setIsSuccessEditActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessEditActivityMapping]);

  useEffect(() => {
    if (isErrorEditActivityMapping) {
      setTimeout(() => {
        setIsErrorEditActivityMapping(false);
      }, 3000);
    }
  }, [isErrorEditActivityMapping]);

  const [editActivityMappingModal, setEditActivityMappingModal] =
    useState(false);
  const handleEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };

  const handleCloseEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };
  const initialValueForEditActivityMapping = {
    bin: "",
  };

  const validationSchemaForEditActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForEditActivityMapping = async (values, reset) => {
    const payload = {
      itemId: ActivityMappingData.itemId,
      warehouseId: warehouseIdSelected?.value,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedOpenBin?.value,
    };

    // let res = await editBinAllocation(payload, jwtToken);

    // if (res.status) {
    //   setIsSuccessEditActivityMapping(true);
    //   getCustody(warehouseIdSelected?.value, jwtToken);
    // }
    // if (!res.status) {
    //   setIsErrorEditActivityMapping(true);
    // }
    // setSelectedOpenBin("");
  };
  const formikForEdit = useFormik({
    initialValues: initialValueForEditActivityMapping,
    validationSchema: validationSchemaForEditActivityMapping,
    onSubmit: onSubmitForEditActivityMapping,
    enableReinitialize: true,
  });

  const [warehouseTypesSelectedForEdit, setWarehouseTypesSelectedForEdit] =
    useState("");
  const [itemCodeSelectedForEdit, setItemCodeSelectedForEdit] = useState("");
  const [acnTypeSelectedForEdit, setAcnTypeSelectedForEdit] = useState("");
  const [zoneSelectedForEdit, setZoneSelectedForEdit] = useState("");
  const [sectionSelectedForEdit, setSectionSelectedForEdit] = useState("");
  const [rackSelectedForEdit, setRackSelectedForEdit] = useState("");
  const [locationSelectedForEdit, setLocationSelectedForEdit] = useState("");

  const [singleFgDataForUpdate, setSingleFgDataForUpdate] = useState({});
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const handleOpenUpdateModal = (singleData) => {
    getWarehousesByMovement(singleData.acnId, jwtToken);
    // getZonesByWarehouse(singleData.zoneId, jwtToken);
    getLevel1ByLevel(singleData.warehouseId, 0, jwtToken);
    getLevel2ByLevel(singleData.warehouseId, singleData.zoneId, jwtToken);
    getLevel3ByLevel(singleData.warehouseId, singleData.sectionId, jwtToken);
    getLevel4ByLevel(singleData.warehouseId, singleData.rackId, jwtToken);
    setWarehouseTypesSelectedForEdit({
      label: singleData.warehouseCode,
      value: singleData.warehouseId,
    });
    setItemCodeSelectedForEdit({
      label: singleData.itemCode,
      value: singleData.itemId,
    });

    setdppIdForUpdateSelected({
      label: singleData.dppCode,
      value: singleData.dppId,
      industryId: singleData.industryId,
    });

    setAcnTypeSelectedForEdit({
      label: singleData.acnCode,
      value: singleData.acnId,
    });
    setZoneSelectedForEdit({
      label: singleData.zone,
      value: singleData.zoneId,
    });
    setSectionSelectedForEdit({
      label: singleData.section,
      value: singleData.sectionId,
    });
    setRackSelectedForEdit({
      label: singleData.rack,
      value: singleData.rackId,
    });
    setLocationSelectedForEdit({
      label: singleData.location,
      value: singleData.locationId,
    });
    setSingleFgDataForUpdate(singleData);
    setOpenUpdateModal(true);

    // getWarehousesByMovement(
    //   acnTypeSelectedForEdit?.value,

    //   jwtToken
    // );
  };

  const handleChangeWarehouseForEdit = (selectedOption) => {
    setWarehouseTypesSelectedForEdit(selectedOption);
    setZoneSelectedForEdit("");
  };
  const handleChangeAcnForEdit = (selectedOption) => {
    setAcnTypeSelectedForEdit(selectedOption);
  };
  const handleChangeZoneForEdit = (selectedOption) => {
    setZoneSelectedForEdit(selectedOption);
    setSectionSelectedForEdit("");
  };
  const handleChangeSectionForEdit = (selectedOption) => {
    setSectionSelectedForEdit(selectedOption);
    setRackSelectedForEdit("");
  };
  const handleChangeRackForEdit = (selectedOption) => {
    setRackSelectedForEdit(selectedOption);
    setLocationSelectedForEdit("");
  };
  const handleChangeLocationForEdit = (selectedOption) => {
    setLocationSelectedForEdit(selectedOption);
  };
  // dppId: values.DPPID,
  //     transferDate: values.TransferDate,
  //     fromEntity: values.FromEntity,
  //     toEntity: values.ToEntity,
  //     locationFrom: values.LocationFrom,
  //     locationTo: values.LocationTo,
  //     transferMode: values.TransferMode,
  //     proofDocUrl: values.ProofDocumentURL,

  const initialValueForUpdate = {
    DPPID: singleFgDataForUpdate.dppCode,
    FromEntity: singleFgDataForUpdate.fromEntity,
    ToEntity: singleFgDataForUpdate.toEntity,
    LocationFrom: singleFgDataForUpdate.locationFrom,
    LocationTo: singleFgDataForUpdate.locationTo,
    TransferMode: singleFgDataForUpdate.transferMode,
    ProofDocumentURL: singleFgDataForUpdate.proofDocUrl,
    carbonFootprint: singleFgDataForUpdate.carbonFootprint,
    TransferDate: singleFgDataForUpdate.transferDate
      ? (() => {
        const [month, day, year] =
          singleFgDataForUpdate.transferDate.split("/");
        return `${year}-${month}-${day}`; // yyyy-MM-dd (safe for inputs/APIs)
      })()
      : "",
  };

  const handleCloseModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [editButtonName, setEditButtonName] = useState("Update");

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");

    const formData = new FormData();

    formData.append("udBy", userId);
    formData.append("chainId", singleFgDataForUpdate.chainId);
    formData.append("dppId", singleFgDataForUpdate?.dppId);
    formData.append("fromEntity", values.FromEntity);
    formData.append("toEntity", values.ToEntity);
    formData.append("locationFrom", values.LocationFrom);
    formData.append("locationTo", values.LocationTo);
    formData.append("transferMode", values.TransferMode);
    formData.append("proofDocUrl", values.ProofDocumentURL);
    formData.append("carbonFootprint", values.carbonFootprint);
    formData.append("transferDate", values.TransferDate);
    formData.append("documentType", "custodyImage");
    formData.append("moduleName", "chainOfCustody");

    const documentDetails = [];

    if (values.file) {
      formData.append("attachments", values.file);

      documentDetails.push({
        fileName: values.file.name,
        fileType: "custodyImage",
      });
    }

    if (values.transportCertification) {
      formData.append("transportCertificate", values.transportCertification);
    }

    formData.append("documentDetails", JSON.stringify(documentDetails));

    if (values.file) {
      formData.append("attachments", values.file);
    }

    let res = await editCustody(formData, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getCustody(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseModal();
        setEditButtonName("Update");
      }, 3000);
    } else {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForAssembly,
    validationSchema: () =>
      getValidationSchema(dppIdForUpdateSelected?.industryId),
    enableReinitialize: true,
  });
  const [isErrorDeleteActivityMapping, setIsErrorDeleteActivityMapping] =
    useState(false);
  useEffect(() => {
    if (isErrorDeleteActivityMapping) {
      setTimeout(() => {
        setIsErrorDeleteActivityMapping(false);
      }, 3000);
    }
  }, [isErrorDeleteActivityMapping]);

  const [openDeleteActivityMappingModal, setOpenDeleteActivityMappingModal] =
    useState(false);

  const handleOpenDeleteActivityMappingModal = (data = {}) => {
    setActivityMappingData(data);
    setOpenDeleteActivityMappingModal(true);
  };

  const handleCloseDeleteActivityMappingModal = () => {
    setOpenDeleteActivityMappingModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
  // const [editButtonName, setEditButtonName] = useState("Submit");

  const onClickDeleteActivityMapping = async () => {
    // let res = await removeBinAllocation(
    //   warehouseIdSelected?.value,
    //   ActivityMappingData.itemId,
    //   ActivityMappingData.zoneId,
    //   ActivityMappingData.locationId,
    //   jwtToken
    // );
    // if (res.status) {
    //   getCustody(warehouseIdSelected?.value, jwtToken);
    //   setOpenDeleteActivityMappingModal(false);
    // }
    // if (!res.status) {
    //   setDeleteErrorMsg(res.data.response.data.msg);
    //   setIsErrorDeleteActivityMapping(true);
    // }
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const data = getRelationLocationReducer.locations?.data || [];
  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };
  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadForCustody(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        getCustody(dppIdSelectedForGlobalFilter?.value, jwtToken);
        setUploadCsvFilter(false);
      }

      showUploadNotification(res);
    } catch (error) {
      showUploadNotification(error);
    }
  };


  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  const subModuleId = "269b317f-3fc3-4ce8-b885-0817acf36a66";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  // let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);
  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getCustody(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  const [isUploading, setIsUploading] = useState(false);

  const uploadDocumentHandler = async () => {
    if (!formik.values.file) return;

    setIsUploading(true);

    const data = new FormData();

    // 🔑 Must match Postman keys
    data.append("File", formik.values.file); // file
    data.append("module_name", "custody"); // text

    try {
      const res = await uploadForUrl(data);
      console.log(res);

      if (res?.status) {
        const fileUrl = res?.data?.data?.uploadedFiles?.[0]?.fileUrl;

        // auto-fill Proof Document URL
        formik.setFieldValue("ProofDocumentURL", fileUrl);

        DataUploadSuccessNotification();
      } else {
        DataUploadFailureNotification(res?.data?.data?.msg);
      }
    } catch (error) {
      console.error(error);
      DataUploadFailureNotification("Upload failed");
    } finally {
      setIsUploading(false);
    }
  };

  const uploadDocumentHandlerForUpdate = async () => {
    if (!formikForUpdate.values.file) return;

    setIsUploading(true);

    const data = new FormData();

    // 🔑 Must match Postman keys
    data.append("File", formikForUpdate.values.file); // file
    data.append("module_name", "custody"); // text

    try {
      const res = await uploadForUrl(data);
      console.log(res);

      if (res?.status) {
        const fileUrl = res?.data?.data?.uploadedFiles?.[0]?.fileUrl;

        // auto-fill Proof Document URL
        formikForUpdate.setFieldValue("ProofDocumentURL", fileUrl);

        DataUploadSuccessNotification();
      } else {
        DataUploadFailureNotification(res?.data?.data?.msg);
      }
    } catch (error) {
      console.error(error);
      DataUploadFailureNotification("Upload failed");
    } finally {
      setIsUploading(false);
    }
  };

  const hideProductImageUrl = true;

  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={4}>
                {allocateAccess && (
                  <Tooltip>
                    <CreateButton
                      tooltip="Add Custody"
                      color="info"
                      variant="contained"
                      type="button"
                      iconOnly
                      onClick={(event) => {
                        handleAllocateItemModal();
                        getWarehouses(jwtToken);
                        getItemMaster(jwtToken);
                        getAcn(jwtToken);
                        getRelationLocation(jwtToken);
                      }}
                      style={{ borderRadius: "5px" }}
                      size="small"
                    >
                      <Icon>add</Icon>
                    </CreateButton>
                  </Tooltip>
                )}

                <CSVLink {...csvLink}>
                  <DownloadDataButton
                    tooltip="Download Custody List"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadDataButton>
                </CSVLink>

                {
                  //  uploadFG &&
                  <UploadButton
                    tooltip="Upload CSV"
                    //   disabled={!uploadItem}
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="info"
                    iconOnly
                    onClick={uploadCsvFilterHandler}
                  >
                    <Icon>upload</Icon>
                  </UploadButton>
                }

                <CSVLink {...csvLink2}>
                  <DownloadButton
                    tooltip="Download Template"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                </CSVLink>
                {/* <Tooltip title="Upload CSV">
                    <MDButton
                      style={{ marginLeft: "1rem" }}
                      // disabled={!uploadItem}
                      type="button"
                      variant="outlined"
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </MDButton>
                  </Tooltip> */}
              </MDBox>
            </MDBox>

            {uploadCsvFilter && (
              <div style={{ marginLeft: "1", marginTop: "0.5rem" }}>
                <div>
                  <input
                    className="choose_file"
                    style={{
                      marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />
                  <MDButton
                    disabled={
                      !uploadCsvData?.name || uploadCsvData?.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    style={{
                      marginLeft: { xs: "1.5rem", lg: "1" },
                      marginTop: "0rem",
                    }}
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>
                <div style={{ marginBottom: "-20px" }}>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginLeft: "30px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload
                    <strong>".csv"</strong> file only
                  </span>
                </div>
              </div>
            )}
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                  // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            <MDBox pt={0}>
              {/* {loadingForDynamicColumn && ( */}
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                tableSearch={true}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25, 30],
                }}
                showTotalEntries={true}
                noEndBorder
                options={{ draggable: false }}
                // serverSidePagination={true}
                // paginationObj={paginationObj}
                // pageNoValue={pageNo}
                // rowsPerPageValue={rowsPerPage}
                // pageNoProp={importPageNo}
                // rowsPerPageProp={importRowsPerPage}
                // searchProp={importSearch}
                loading={loading}
                hideColumns={hiddenColumsDetails}
                visibleColumns2={dynamicColumnData?.visibleFields}
                dynamicColumnData={dynamicColumnData}
                handleOpenCreateColumnReorderModal={
                  handleOpenCreateColumnReorderModal
                }
                subModuleId={subModuleId}
                userId={userId}
              />
              {/* )} */}
            </MDBox>
            <Modal
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "0.5rem" }}
                    color="error"
                    onClick={deleteTripNo}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteAssembly}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForAssembly}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessForAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox>
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={6}>
                          <MDBox>
                            <MDTypography variant="h6">DPP Code</MDTypography>
                            <MDInput
                              type="text"
                              name="DPPID"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.DPPID}
                              error={
                                formikForUpdate.touched.DPPID &&
                                formikForUpdate.errors.DPPID &&
                                true
                              }
                              disabled={true}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.DPPID &&
                              formikForUpdate.errors.DPPID && (
                                <TextError msg={formikForUpdate.errors.DPPID} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Transfer Date
                            </MDTypography>
                            <MDInput
                              type="date"
                              name="TransferDate"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.TransferDate}
                              error={
                                formikForUpdate.touched.TransferDate &&
                                formikForUpdate.errors.TransferDate &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.TransferDate &&
                              formikForUpdate.errors.TransferDate && (
                                <TextError
                                  msg={formikForUpdate.errors.TransferDate}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={1}>
                          <MDBox>
                            <MDTypography variant="h6">
                              From Entity
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="FromEntity"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.FromEntity}
                              error={
                                formikForUpdate.touched.FromEntity &&
                                formikForUpdate.errors.FromEntity &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.FromEntity &&
                              formikForUpdate.errors.FromEntity && (
                                <TextError
                                  msg={formikForUpdate.errors.FromEntity}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">To Entity</MDTypography>
                            <MDInput
                              type="text"
                              name="ToEntity"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ToEntity}
                              error={
                                formikForUpdate.touched.ToEntity &&
                                formikForUpdate.errors.ToEntity &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ToEntity &&
                              formikForUpdate.errors.ToEntity && (
                                <TextError
                                  msg={formikForUpdate.errors.ToEntity}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={1}>
                          <MDBox>
                            <MDTypography variant="h6">
                              Location From
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="LocationFrom"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.LocationFrom}
                              error={
                                formikForUpdate.touched.LocationFrom &&
                                formikForUpdate.errors.LocationFrom &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.LocationFrom &&
                              formikForUpdate.errors.LocationFrom && (
                                <TextError
                                  msg={formikForUpdate.errors.LocationFrom}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Location To
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="LocationTo"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.LocationTo}
                              error={
                                formikForUpdate.touched.LocationTo &&
                                formikForUpdate.errors.LocationTo &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.LocationTo &&
                              formikForUpdate.errors.LocationTo && (
                                <TextError
                                  msg={formikForUpdate.errors.LocationTo}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6} mt={1}>
                          <MDBox mb={1}>
                            <MDTypography variant="h6">
                              Transfer Mode
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="TransferMode"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.TransferMode}
                              error={
                                formikForUpdate.touched.TransferMode &&
                                formikForUpdate.errors.TransferMode &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.TransferMode &&
                              formikForUpdate.errors.TransferMode && (
                                <TextError
                                  msg={formikForUpdate.errors.TransferMode}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Carbon Footprint(kg CO₂e)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="carbonFootprint"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.carbonFootprint}
                              error={
                                formikForUpdate.touched.carbonFootprint &&
                                formikForUpdate.errors.carbonFootprint &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.carbonFootprint &&
                              formikForUpdate.errors.carbonFootprint && (
                                <TextError
                                  msg={formikForUpdate.errors.carbonFootprint}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={2}>
                            <MDTypography variant="h6" fontWeight={500} mb={1}>
                              Upload Document
                              {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                            </MDTypography>

                            <MDBox width="100%">
                              <input
                                id="edit-upload-file"
                                type="file"
                                hidden
                                accept=".jpg,.jpeg,.png,.webp , .pdf"
                                onChange={(e) => {
                                  const file = e.currentTarget.files[0];
                                  if (!file) return;

                                  const allowedTypes = [
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "image/webp",
                                    "application/pdf",
                                  ];

                                  if (!allowedTypes.includes(file.type)) {
                                    formikForUpdate.setFieldError(
                                      "file",
                                      "Only JPG, JPEG, PNG, WEBP and images are allowed.",
                                    );
                                    formikForUpdate.setFieldValue("file", null);
                                    e.target.value = "";
                                    return;
                                  }

                                  formikForUpdate.setFieldError("file", "");
                                  formikForUpdate.setFieldValue("file", file);
                                }}
                              />

                              {!formikForUpdate.values.file &&
                                !singleFgDataForUpdate?.name ? (
                                <label
                                  htmlFor="edit-upload-file"
                                  style={{ display: "block", width: "100%" }}
                                >
                                  <MDButton
                                    variant="outlined"
                                    component="span"
                                    color="info"
                                    fullWidth
                                    sx={{
                                      height: "34px",
                                      minHeight: "34px",
                                      maxHeight: "34px",
                                      padding: "4px 16px",
                                      boxSizing: "border-box",
                                      fontSize: "0.85rem",
                                      borderColor:
                                        formikForUpdate.touched.file &&
                                          formikForUpdate.errors.file
                                          ? "#f87f7f"
                                          : undefined,
                                      color:
                                        formikForUpdate.touched.file &&
                                          formikForUpdate.errors.file
                                          ? "#f87f7f"
                                          : undefined,
                                    }}
                                  >
                                    Choose File
                                  </MDButton>
                                </label>
                              ) : (
                                <label
                                  htmlFor="edit-upload-file"
                                  style={{
                                    width: "100%",
                                    cursor: "pointer",
                                    display: "block",
                                  }}
                                >
                                  <MDBox
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    px={1.5}
                                    sx={{
                                      height: "34px",
                                      border:
                                        formikForUpdate.touched.file &&
                                          formikForUpdate.errors.file
                                          ? "1px dashed #f87f7f"
                                          : "1px dashed #1A73E8",
                                      borderRadius: "8px",
                                      backgroundColor: "#fff",
                                      boxSizing: "border-box",
                                      transition: "background-color 0.2s",
                                      "&:hover": { backgroundColor: "#f8f9fa" },
                                    }}
                                  >
                                    <MDTypography
                                      variant="body2"
                                      color="text"
                                      sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: 1,
                                        fontSize: "14px",
                                        mr: 1,
                                      }}
                                      title={
                                        formikForUpdate.values.file?.name ??
                                        singleFgDataForUpdate?.name
                                      }
                                    >
                                      {formikForUpdate.values.file?.name ??
                                        singleFgDataForUpdate?.name ??
                                        "Choose File"}
                                    </MDTypography>
                                    <Icon fontSize="small" color="info">
                                      edit
                                    </Icon>
                                  </MDBox>
                                </label>
                              )}

                              {/* Error Display */}
                              {formikForUpdate.touched.file &&
                                formikForUpdate.errors.file && (
                                  <TextError
                                    msg={formikForUpdate.errors.file}
                                  />
                                )}
                            </MDBox>
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={2} ml={1}>
                            <MDTypography variant="h6" fontWeight={500} mb={1}>
                              UN38.3 Transport Certification
                              {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                            </MDTypography>

                            <MDBox width="100%">
                              <input
                                id="edit-upload-transport-cert"
                                type="file"
                                hidden
                                accept=".jpg,.jpeg,.png,.webp,.pdf"
                                onChange={(e) => {
                                  const file = e.currentTarget.files[0];
                                  if (!file) return;

                                  const allowedTypes = [
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "image/webp",
                                    "application/pdf",
                                  ];

                                  if (!allowedTypes.includes(file.type)) {
                                    formikForUpdate.setFieldError(
                                      "transportCertification",
                                      "Only JPG, PNG, and PDF files are allowed.",
                                    );
                                    formikForUpdate.setFieldValue(
                                      "transportCertification",
                                      null,
                                    );
                                    e.target.value = "";
                                    return;
                                  }

                                  formikForUpdate.setFieldError(
                                    "transportCertification",
                                    "",
                                  );
                                  formikForUpdate.setFieldValue(
                                    "transportCertification",
                                    file,
                                  );
                                }}
                              />

                              {!formikForUpdate.values.transportCertification &&
                                !singleFgDataForUpdate?.transportCertificationName ? (
                                <label
                                  htmlFor="edit-upload-transport-cert"
                                  style={{ display: "block", width: "100%" }}
                                >
                                  <MDButton
                                    variant="outlined"
                                    component="span"
                                    color="info"
                                    fullWidth
                                    sx={{
                                      height: "34px",
                                      minHeight: "34px",
                                      maxHeight: "34px",
                                      padding: "4px 16px",
                                      boxSizing: "border-box",
                                      fontSize: "0.85rem",
                                      borderColor:
                                        formikForUpdate.touched
                                          .transportCertification &&
                                          formikForUpdate.errors
                                            .transportCertification
                                          ? "#f87f7f"
                                          : undefined,
                                      color:
                                        formikForUpdate.touched
                                          .transportCertification &&
                                          formikForUpdate.errors
                                            .transportCertification
                                          ? "#f87f7f"
                                          : undefined,
                                    }}
                                  >
                                    Choose File
                                  </MDButton>
                                </label>
                              ) : (
                                <label
                                  htmlFor="edit-upload-transport-cert"
                                  style={{
                                    width: "100%",
                                    cursor: "pointer",
                                    display: "block",
                                  }}
                                >
                                  <MDBox
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    px={1.5}
                                    sx={{
                                      height: "34px",
                                      border:
                                        formikForUpdate.touched
                                          .transportCertification &&
                                          formikForUpdate.errors
                                            .transportCertification
                                          ? "1px dashed #f87f7f"
                                          : "1px dashed #1A73E8",
                                      borderRadius: "8px",
                                      backgroundColor: "#fff",
                                      boxSizing: "border-box",
                                      transition: "background-color 0.2s",
                                      "&:hover": { backgroundColor: "#f8f9fa" },
                                    }}
                                  >
                                    <MDTypography
                                      variant="body2"
                                      color="text"
                                      sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: 1,
                                        fontSize: "14px",
                                        mr: 1,
                                      }}
                                      title={
                                        formikForUpdate.values
                                          .transportCertification?.name ??
                                        singleFgDataForUpdate?.transportCertificationName
                                      }
                                    >
                                      {formikForUpdate.values
                                        .transportCertification?.name ??
                                        singleFgDataForUpdate?.transportCertificationName ??
                                        "Choose File"}
                                    </MDTypography>
                                    <Icon fontSize="small" color="info">
                                      edit
                                    </Icon>
                                  </MDBox>
                                </label>
                              )}

                              {/* Error Display */}
                              {formikForUpdate.touched.transportCertification &&
                                formikForUpdate.errors
                                  .transportCertification && (
                                  <TextError
                                    msg={
                                      formikForUpdate.errors
                                        .transportCertification
                                    }
                                  />
                                )}
                            </MDBox>
                          </MDBox>
                        </Grid>

                        {!hideProductImageUrl && (
                          <Grid item xs={12} lg={12}>
                            <MDBox ml={1} mb={1}>
                              <MDTypography variant="h6">
                                Proof Document URL
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="ProofDocumentURL"
                                fullWidth
                                autoComplete="off"
                                onBlur={formikForUpdate.handleBlur}
                                onChange={formikForUpdate.handleChange}
                                value={formikForUpdate.values.ProofDocumentURL}
                                error={
                                  formikForUpdate.touched.ProofDocumentURL &&
                                  formikForUpdate.errors.ProofDocumentURL &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "10px",
                                  },
                                  maxLength: 45,
                                }}
                              />
                              {formikForUpdate.touched.ProofDocumentURL &&
                                formikForUpdate.errors.ProofDocumentURL && (
                                  <TextError
                                    msg={
                                      formikForUpdate.errors.ProofDocumentURL
                                    }
                                  />
                                )}
                            </MDBox>
                          </Grid>
                        )}

                        {/* <Grid item xs={12} lg={6}>
                          <MDBox mb={2} ml={1} >
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Status
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={70}
                              placeholder="Select..."
                              name="location"
                              options={level4Options}
                              value={locationSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeLocationForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "location",
                                  selectedOption
                                );
                              }}
                            />
                            {formikForUpdate.touched.location &&
                              formikForUpdate.errors.location && (
                                <TextError
                                  msg={formikForUpdate.errors.location}
                                />
                              )}
                          </MDBox>
                        </Grid> */}

                        <Grid item xs={12}>
                          <MDBox>
                            <Collapse in={isErrorForUpdate}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {errorMsgForUpdate}
                              </Alert>
                            </Collapse>
                            <Collapse in={isSuccessForUpdate}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsSuccessForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Updated successfully
                              </Alert>
                            </Collapse>
                          </MDBox>
                        </Grid>
                        {/* <MDBox mt={3} ml={10}> */}

                        {/* <MDButton
                          // variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton> */}

                        {/* Submit Button */}
                        <MDButton
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Chain of Custody Record
                  </MDTypography>
                  <MDBox>
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAllocateItemModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            DPP Code{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={200}
                            placeholder="Choose one..."
                            name="DPPID"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "DPPID" },
                              });
                            }}
                            value={dppIdSelected}
                            options={dppOptions}
                            onChange={(selectedOption) => {
                              handleChangeDpp(selectedOption);
                              formik.setFieldValue("DPPID", selectedOption);

                              if (!selectedOption) {
                                setdppIdSelected(null);
                                formik.setFieldValue("FromEntity", "");
                                setFromEntityOptions([]); // optional but recommended
                              } else {
                                setdppIdSelected(selectedOption);
                              }
                            }}
                          />
                          {formik.touched.DPPID && formik.errors.DPPID && (
                            <TextError msg={formik.errors.DPPID} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1} mb={2}>
                          <MDTypography variant="h6">
                            Transfer Date
                          </MDTypography>
                          {/* <MDInput
                            type="date"
                            name="TransferDate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.TransferDate}
                            error={
                              formik.touched.TransferDate &&
                              formik.errors.TransferDate &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          /> */}
                          <MDInput
                            type="date"
                            name="TransferDate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.TransferDate}
                            error={
                              formik.touched.TransferDate &&
                              formik.errors.TransferDate &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                              min: today, // Cannot select past date
                            }}
                          />
                          {formik.touched.TransferDate &&
                            formik.errors.TransferDate && (
                              <TextError msg={formik.errors.TransferDate} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">From Entity</MDTypography>

                          <MDInput
                            type="text"
                            name="FromEntity"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.FromEntity}
                            error={
                              formik.touched.FromEntity &&
                              Boolean(formik.errors.FromEntity)
                            }
                            disabled={entityOptions.length > 0} // 🔥 Disables only when data exists
                            inputProps={{
                              style: { height: "10px" },
                              maxLength: 45,
                            }}
                          />

                          {formik.touched.FromEntity &&
                            formik.errors.FromEntity && (
                              <TextError msg={formik.errors.FromEntity} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">To Entity</MDTypography>
                          <MDInput
                            type="text"
                            name="ToEntity"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ToEntity}
                            error={
                              formik.touched.ToEntity &&
                              formik.errors.ToEntity &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.ToEntity &&
                            formik.errors.ToEntity && (
                              <TextError msg={formik.errors.ToEntity} />
                            )}
                        </MDBox>
                      </Grid>
                      {/* <Grid item xs={12} lg={6}>
                        <MDBox >
                          <MDTypography variant="h6">
                            Location From
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="LocationFrom"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.LocationFrom}
                            error={
                              formik.touched.LocationFrom &&
                              formik.errors.LocationFrom &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.LocationFrom &&
                            formik.errors.LocationFrom && (
                              <TextError msg={formik.errors.LocationFrom} />
                            )}
                        </MDBox>
                      </Grid> */}
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Location From
                          </MDTypography>

                          <MDInput
                            type="text"
                            name="LocationFrom"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.LocationFrom}
                            error={
                              formik.touched.LocationFrom &&
                              Boolean(formik.errors.LocationFrom)
                            }
                            disabled={locationFromOptions.length > 0} // 🔥 Disables only when data exists
                            inputProps={{
                              style: { height: "10px" },
                              maxLength: 45,
                            }}
                          />

                          {formik.touched.LocationFrom &&
                            formik.errors.LocationFrom && (
                              <TextError msg={formik.errors.LocationFrom} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Location To</MDTypography>
                          <MDInput
                            type="text"
                            name="LocationTo"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.LocationTo}
                            error={
                              formik.touched.LocationTo &&
                              formik.errors.LocationTo &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.LocationTo &&
                            formik.errors.LocationTo && (
                              <TextError msg={formik.errors.LocationTo} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox>
                          <MDTypography variant="h6" fontWeight={500}>
                            Upload Document
                            {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                          </MDTypography>

                          <MDBox width="100%">
                            <input
                              id="upload-file"
                              type="file"
                              hidden
                              accept=".jpg,.jpeg,.png,.webp,.pdf"
                              onChange={(e) => {
                                const file = e.currentTarget.files[0];
                                if (!file) return;

                                const allowedTypes = [
                                  "image/jpeg",
                                  "image/jpg",
                                  "image/png",
                                  "image/webp",
                                  "application/pdf",
                                ];

                                if (!allowedTypes.includes(file.type)) {
                                  formik.setFieldError(
                                    "file",
                                    "Only JPG, JPEG, PNG, WEBP images, and PDF files are allowed.",
                                  );
                                  formik.setFieldValue("file", null);
                                  e.target.value = "";
                                  return;
                                }

                                formik.setFieldError("file", "");
                                formik.setFieldValue("file", file);
                              }}
                            />

                            {!formik.values.file ? (
                              <label
                                htmlFor="upload-file"
                                style={{ display: "block", width: "100%" }}
                              >
                                <MDButton
                                  variant="outlined"
                                  component="span"
                                  color="info"
                                  fullWidth
                                  sx={{
                                    height: "34px",
                                    minHeight: "34px",
                                    maxHeight: "34px",
                                    padding: "4px 16px",
                                    boxSizing: "border-box",
                                    fontSize: "0.85rem",
                                    borderColor:
                                      formik.touched.file && formik.errors.file
                                        ? "#f87f7f"
                                        : undefined,
                                    color:
                                      formik.touched.file && formik.errors.file
                                        ? "#f87f7f"
                                        : undefined,
                                  }}
                                >
                                  Choose File
                                </MDButton>
                              </label>
                            ) : (
                              <label
                                htmlFor="upload-file"
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  display: "block",
                                }}
                              >
                                <MDBox
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  px={1.5}
                                  sx={{
                                    height: "34px",
                                    border:
                                      formik.touched.file && formik.errors.file
                                        ? "1px dashed #f87f7f"
                                        : "1px dashed #1A73E8",
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    boxSizing: "border-box",
                                    transition: "background-color 0.2s",
                                    "&:hover": { backgroundColor: "#f8f9fa" },
                                  }}
                                >
                                  <MDTypography
                                    variant="body2"
                                    color="text"
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      flex: 1,
                                      fontSize: "14px",
                                      mr: 1,
                                    }}
                                    title={formik.values.file?.name}
                                  >
                                    {formik.values.file?.name}
                                  </MDTypography>
                                  <Icon fontSize="small" color="info">
                                    edit
                                  </Icon>
                                </MDBox>
                              </label>
                            )}

                            {formik.touched.file && formik.errors.file && (
                              <TextError msg={formik.errors.file} />
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6" fontWeight={500}>
                            UN38.3 Transport Certification
                            {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                          </MDTypography>

                          <MDBox width="100%">
                            <input
                              id="upload-transport-cert"
                              type="file"
                              hidden
                              accept=".jpg,.jpeg,.png,.pdf"
                              onChange={(e) => {
                                const file = e.currentTarget.files[0];
                                if (!file) return;

                                const allowedTypes = [
                                  "image/jpeg",
                                  "image/jpg",
                                  "image/png",
                                  "application/pdf",
                                ];

                                if (!allowedTypes.includes(file.type)) {
                                  formik.setFieldError(
                                    "transportCertification",
                                    "Only JPG, PNG, and PDF files are allowed.",
                                  );
                                  formik.setFieldValue(
                                    "transportCertification",
                                    null,
                                  );
                                  e.target.value = "";
                                  return;
                                }

                                formik.setFieldError(
                                  "transportCertification",
                                  "",
                                );
                                formik.setFieldValue(
                                  "transportCertification",
                                  file,
                                );
                              }}
                            />

                            {!formik.values.transportCertification ? (
                              <label
                                htmlFor="upload-transport-cert"
                                style={{ display: "block", width: "100%" }}
                              >
                                <MDButton
                                  variant="outlined"
                                  component="span"
                                  color="info"
                                  fullWidth
                                  sx={{
                                    height: "34px",
                                    minHeight: "34px",
                                    maxHeight: "34px",
                                    padding: "4px 16px",
                                    boxSizing: "border-box",
                                    fontSize: "0.85rem",
                                    borderColor:
                                      formik.touched.transportCertification &&
                                        formik.errors.transportCertification
                                        ? "#f87f7f"
                                        : undefined,
                                    color:
                                      formik.touched.transportCertification &&
                                        formik.errors.transportCertification
                                        ? "#f87f7f"
                                        : undefined,
                                  }}
                                >
                                  Choose File
                                </MDButton>
                              </label>
                            ) : (
                              <label
                                htmlFor="upload-transport-cert"
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  display: "block",
                                }}
                              >
                                <MDBox
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  px={1.5}
                                  sx={{
                                    height: "34px",
                                    border:
                                      formik.touched.transportCertification &&
                                        formik.errors.transportCertification
                                        ? "1px dashed #f87f7f"
                                        : "1px dashed #1A73E8",
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    boxSizing: "border-box",
                                    transition: "background-color 0.2s",
                                    "&:hover": { backgroundColor: "#f8f9fa" },
                                  }}
                                >
                                  <MDTypography
                                    variant="body2"
                                    color="text"
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      flex: 1,
                                      fontSize: "14px",
                                      mr: 1,
                                    }}
                                    title={
                                      formik.values.transportCertification?.name
                                    }
                                  >
                                    {formik.values.transportCertification?.name}
                                  </MDTypography>
                                  <Icon fontSize="small" color="info">
                                    edit
                                  </Icon>
                                </MDBox>
                              </label>
                            )}

                            {/* Error Display */}
                            {formik.touched.transportCertification &&
                              formik.errors.transportCertification && (
                                <TextError
                                  msg={formik.errors.transportCertification}
                                />
                              )}
                          </MDBox>
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6} mt={2} mb={2}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Transfer Mode
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="TransferMode"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.TransferMode}
                            error={
                              formik.touched.TransferMode &&
                              formik.errors.TransferMode &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.TransferMode &&
                            formik.errors.TransferMode && (
                              <TextError msg={formik.errors.TransferMode} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Carbon Footprint(kg CO₂e)
                          </MDTypography>
                          <MDInput
                            type="number"
                            name="carbonFootprint"
                            placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.carbonFootprint}
                            error={
                              formik.touched.carbonFootprint &&
                              formik.errors.carbonFootprint &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.carbonFootprint &&
                            formik.errors.carbonFootprint && (
                              <TextError msg={formik.errors.carbonFootprint} />
                            )}
                        </MDBox>
                      </Grid>
                      {!hideProductImageUrl && (
                        <Grid item xs={12} lg={12}>
                          <MDBox mb={1}>
                            <MDTypography variant="h6">
                              Proof Document URL
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="ProofDocumentURL"
                              fullWidth
                              autoComplete="off"
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.ProofDocumentURL}
                              error={
                                formik.touched.ProofDocumentURL &&
                                formik.errors.ProofDocumentURL &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />

                            {formik.touched.ProofDocumentURL &&
                              formik.errors.ProofDocumentURL && (
                                <TextError
                                  msg={formik.errors.ProofDocumentURL}
                                />
                              )}
                          </MDBox>
                        </Grid>
                      )}

                      {/* <Grid item xs={12} lg={12}>
                      <MDBox mb={2}>
  <MDTypography variant="h6">Assesment Date</MDTypography>
  <MDInput
    type="date"  // Change this from "text" to "date"
    name="Collection"
    fullWidth
    autoComplete="off"
    onBlur={formik.handleBlur}
    onChange={formik.handleChange}
    value={formik.values.Collection}
    error={formik.touched.Collection && formik.errors.Collection && true}
    inputProps={{
      style: {
        height: "10px",
      },
    }}
  />
  {formik.touched.Collection && formik.errors.Collection && (
    <TextError msg={formik.errors.Collection} />
  )}
</MDBox>

                      </Grid> */}
                      {/* <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Warehouse Code{" "}
                          </MDTypography>

                          <Select
                            isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="warehouseCode"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "warehouseCode" },
                              });
                            }}
                            value={warehouseIdSelected}
                            options={warehouseOptionsByMovement}
                            onChange={(selectedOption) => {
                              handleChangeWarehouse(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "warehouseCode",
                                selectedOption
                              );
                              getLevel1ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel2ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel3ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel4ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                            }}
                          />
                          {formik.touched.warehouseCode &&
                            formik.errors.warehouseCode && (
                              <TextError msg={formik.errors.warehouseCode} />
                            )}
                        </MDBox>
                      </Grid> */}

                      <Grid item xs={12}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                      </Grid>

                      {/* Submit Button */}
                      <MDButton
                        color="info"
                        fullWidth
                        type="submit"
                        disabled={allocateButtonName === "Please wait..."}
                      >
                        {allocateButtonName}
                      </MDButton>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* <Footer /> */}
    </div>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    warehouses: state.warehouses,
    getCustodyReducer: state.getCustodyReducer,
    itemMaster: state.itemMaster,
    zonesByWarehouse: state.zonesByWarehouse,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
    getFromEnitityReducer: state.getFromEnitityReducer,
    openBinsByWarehouse: state.openBinsByWarehouse,
    getRelationLocationReducer: state.getRelationLocationReducer,
    getWarehouseByMovementReducer: state.getWarehouseByMovementReducer,
    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
    getLocationFromReducer: state.getLocationFromReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
    getDPPReducer: state.getDPPReducer,
    getDppDocumentsImageReducer: state.getDppDocumentsImageReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getCustody: (dppId, jwtToken) => dispatch(getCustody(dppId, jwtToken)),
    getLocationFromCustody: (dppId, jwtToken) =>
      dispatch(getLocationFromCustody(dppId, jwtToken)),
    getDppIds: (jwtToken) => dispatch(getDppIds(jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getZonesByWarehouse: (id, jwtToken) =>
      dispatch(getZonesByWarehouse(id, jwtToken)),
    getLevel1ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(warehouseId, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getOpenBinsByWarehouseAndZone: (id, zoneId, jwtToken) =>
      dispatch(getOpenBinsByWarehouseAndZone(id, zoneId, jwtToken)),
    createCustody: (payload, jwtToken) =>
      dispatch(createCustody(payload, jwtToken)),
    deleteCustody: (chainId, userId, jwtToken) =>
      dispatch(deleteCustody(chainId, userId, jwtToken)),
    uploadForCustody: (payload, jwtToken) =>
      dispatch(uploadForCustody(payload, jwtToken)),
    uploadForUrl: (payload, jwtToken) =>
      dispatch(uploadForUrl(payload, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    getWarehousesByMovement: (activityIdSelected, jwtToken) =>
      dispatch(getWarehousesByMovement(activityIdSelected, jwtToken)),
    editCustody: (payload, jwtToken) =>
      dispatch(editCustody(payload, jwtToken)),
    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),
    getFromEntityFromDppId: (dppId, jwtToken) =>
      dispatch(getFromEntityFromDppId(dppId, jwtToken)),

    getDppDocumentsImage: (moduleName, type, name, jwtToken) =>
      dispatch(getDppDocumentsImage(moduleName, type, name, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Custody);
